import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BankAccount } from 'constants/bank-account.constants';
import { formValue, intialMessage, userMessage } from 'constants/ui.constants';
import _ from 'lodash';

interface bankAccountState {
	loading: boolean;
	message: userMessage;
	existingBankAccounts: BankAccount[];
	altshulerAccounts: BankAccount[];
}

const initialState: bankAccountState = {
	loading: false,
	message: intialMessage,
	existingBankAccounts: [],
	altshulerAccounts: [],
};

export const bankAccountSlice = createSlice({
	name: 'bankAccount',
	initialState,
	reducers: {
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
		setMessage: (state, action: PayloadAction<userMessage>) => {
			state.message = action.payload;
		},
		setExistingBankAccounts: (state, action: PayloadAction<Array<BankAccount>>) => {
			action.payload.map((bankAccount: any) => {
				return { ...bankAccount, bankName: bankAccount.bankName.bankName };
			});
			state.existingBankAccounts = action.payload;
		},
		setAltshulerAccounts: (state, action: PayloadAction<Array<BankAccount>>) => {
			state.altshulerAccounts = action.payload;
		},
	},
});

export const { setLoading, setMessage, setExistingBankAccounts, setAltshulerAccounts } = bankAccountSlice.actions;

export const isLoading = (state: any) => state.bankAccount.loading;
export const getMessage = (state: any) => state.bankAccount.message;
export const getExistingBankAccounts = (state: any) => state.bankAccount.existingBankAccounts;
export const getAltshulerAccounts = (state: any) => state.bankAccount.altshulerAccounts;

export default bankAccountSlice.reducer;
